import { render, staticRenderFns } from "./PacketCardMultiPoint.vue?vue&type=template&id=6bd1eb94&scoped=true&"
import script from "./PacketCardMultiPoint.vue?vue&type=script&lang=ts&"
export * from "./PacketCardMultiPoint.vue?vue&type=script&lang=ts&"
import style0 from "./PacketCardMultiPoint.vue?vue&type=style&index=0&id=6bd1eb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1eb94",
  null
  
)

export default component.exports